import ls from 'localstorage-slim';
import {
  RESET_USER_DETAILS,
  SET_USER_DETAILS,
  UPDATE_USER_PROFILE_DETAILS,
  UPDATE_USER_THEME_PREFERENCE,
} from '../actionType/authAction';
import { Login_User_Data_Type } from '../../api/types/auth';

interface Init_State_Type {
  is_logged_in: boolean;
  user_info: Login_User_Data_Type | null;
}

const inital_state: Init_State_Type = {
  is_logged_in: localStorage.getItem('AUI') ? true : false,
  user_info: localStorage.getItem('AUI')
    ? ls.get('AUI', { decrypt: true })
    : null,
};

export const auth_reducer = (
  state = inital_state,
  action: any
): Init_State_Type => {
  switch (action.type) {
    case SET_USER_DETAILS:
      return {
        ...state,
        is_logged_in: true,
        user_info: action.payload,
      };

    case UPDATE_USER_PROFILE_DETAILS:
      return {
        ...state,
        user_info: { ...state.user_info, ...action.payload },
      };

    case UPDATE_USER_THEME_PREFERENCE:
      return {
        ...state,
        user_info: { ...state.user_info, ...action.payload },
      };

    case RESET_USER_DETAILS:
      return {
        ...state,
        is_logged_in: false,
        user_info: null,
      };

    default:
      return state;
  }
};
